import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { withSnackbar } from "notistack";

import AlertDialog from "../../common/AlertDialog";
import { v4 as uuidv4 } from "uuid";

const BranchList = (props) => {
  const [openDeleteConfirmationDialogue, setOpenDeleteConfirmationDialogue] =
    useState(false);

  const handleCloseDeleteConfirmationDialogue = () => {
    setOpenDeleteConfirmationDialogue(false);
  };

  const handleEditBranch = (data) => {
    props.handleOpenBranchForm(data);
  };

  const handleDeleteBranchClick = () => {
    handleCloseDeleteConfirmationDialogue();
    props.handleDelete();
  };

  const handleDeleteBranch = (branch) => {
    setOpenDeleteConfirmationDialogue(true);
    props.handleSetContextBranch(branch);
  };

  return (
    <>
      <List sx={{ width: "100%" }}>
        {props.branches.map((branch) => (
          <ListItem key={uuidv4()} divider disablePadding>
            <ListItemButton>
              <ListItemText primary={branch.Prefix} secondary={branch.Name} />
              <IconButton
                onClick={() => handleEditBranch(branch)}
                color="secondary"
                edge="start"
              >
                <EditIcon />
              </IconButton>
              <IconButton
                onClick={() => handleDeleteBranch(branch)}
                color="primary"
                edge="end"
              >
                <DeleteIcon />
              </IconButton>
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <AlertDialog
        open={openDeleteConfirmationDialogue}
        message={"Are you sure you want to delete the branch ?"}
        handleClose={handleCloseDeleteConfirmationDialogue}
        handleDelete={handleDeleteBranchClick}
      />
    </>
  );
};

export default withSnackbar(BranchList);
